

import React, { useState, useRef } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Fade,
  //IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { motion } from 'framer-motion';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import IconButton from '@mui/material/IconButton';

// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const brandCards = [
  {
    title: 'Insights RM',
    subtitle: 'Accurate Resource Management for Clinical Trials',
    color: '#0cc0df', // Chartreuse
    bullets: [
      'Resource management',
      'Clinical trial management',
      'Demand forecasting',
      'Scenario planning',
    ],
    direction: 'left',
    link: '/insights-rm',
    iconSrc: '/White_Group_Insights_RM.png',
  },
  {
    title: 'CTMS',
    subtitle: 'Improve Clinical Trial Performance',
    color: '#9440dd', // Sky Blue
    bullets: [
      'Manage clinical trial portfolio',
      'Flexible reporting',
      'Monitoring module',
      'Validated system',
    ],
    direction: 'left',
    link: '/ctms',
    iconSrc: '/White_Clipboard_CTMS.png',
  },
  {
    title: 'Professional Services',
    subtitle: 'Expert Technical Solutions',
    color: '#7ed957', // Azure
    bullets: [
      'Dynamic report building',
      'Data integration',
      'Security data & strategy',
      'Top technical experts',
    ],
    direction: 'right',
    link: '/professional-services',
    iconSrc: '/White_Graph_Professional_Services.png',
  },
    {
    title: ' Intrinsic BioPhy',
    subtitle: 'AI Solutions that Transform Operations',
    color: '#e9c71f', // Yellow
    bullets: [
      'Identify gaps between SOPs and regulations  ',
      'Eliminate document duplication',
      'Streamline IQ/OQ/PQ validation cycles',
      //'Save money, eliminate months of manual work',
      ],
    direction: 'right',
    link: '/intrinsic-biophy',
    iconSrc: '/brandlogoBiophy.png',
  },

  {
    title: 'Informer',
    subtitle: 'Data Driven Decisions',
    color: '#004aad', // Yellow
    bullets: [
      'Ensure compliant protocol execution by sites',
      'Efficiently plan clinical trials',
      'Manage studies with clear dashboards',
      'Data driven decisions',
    ],
    direction: 'right',
    link: '/informer',
    iconSrc: '/White_Clipboard_hand_Informer.png',
  },

];




export default function BrandsSection() {
  const scrollRef = useRef(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const scrollLeft = () => {
    scrollRef.current.scrollBy({
      left: -500,
      behavior: 'smooth',
    });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({
      left: 500,
      behavior: 'smooth',
    });
  };


  return (
    <Box
      sx={{
        py: 8,
        px: 0,
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          color: '#333738',
          mb: 4,
          textAlign: 'center',
        }}
      >
        Our Products
      </Typography>




      {/* Scrollable Cards */}
      <Box

        ref={scrollRef}
        sx={{
          display: 'flex',
          
          flexDirection: isSmallScreen ? 'column' : 'row',
          flexWrap: isSmallScreen ? 'nowrap' : 'nowrap',
          gap: 2,
          px: 0,
          scrollBehavior: 'smooth',
          overflowX: isSmallScreen ? 'visible' : 'auto',
          '&::-webkit-scrollbar': { display: 'none' },
        }}

      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: 16,
            transform: 'translateY(-50%)',
            zIndex: 2,
          }}
        >
          <IconButton onClick={scrollLeft}>
            <ArrowBackIosNewIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            right: 16,
            transform: 'translateY(-50%)',
            zIndex: 2,
          }}
        >
          <IconButton onClick={scrollRight}>
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>

        {brandCards.map((card, index) => {
          const offset = index < 2 ? -120 : 120; // 1st two from left, next two from right

          return (
            <motion.div
              key={index}
               style={{ flex: '0 0 auto' }}   
              initial={{ x: offset, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <HoverCard card={card} />
            </motion.div>
          );
        })}

      </Box>


    </Box>
  );
}

function HoverCard({ card }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Paper
      elevation={6}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        width: { xs: 200, sm: 200, md: 240 },
        minHeight: { xs: 280, sm: 260, md: 300 },
        backgroundColor: card.color,
        color: '#333738',
        padding: '10px',
        textAlign: 'left',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'opacity 0.3s ease',
        fontFamily: 'Arial, sans-serif',
        overflow: 'visible',
        transformOrigin: 'center',

      }}

    >
      
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h4" fontWeight="bold" color="white" fontSize="22px" >
            {card.title}
          </Typography>
        </Box>

        <Box sx={{ height: 120,  overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Fade in={!hovered} timeout={300} unmountOnExit>
            <Typography
              variant="body2"
              color="white"
              fontSize="20px"
              sx={{ py: '30px', textAlign: 'center' }}
            >
              {card.subtitle}
            </Typography>
          </Fade>

          <Fade in={hovered} timeout={300} unmountOnExit>
            <Box component="ul" sx={{ pl: 2 }}>
              {card.bullets.map((bullet, i) => (
                <li key={i} style={{ fontSize: '14px', color: 'white' }}>
                  {bullet}
                </li>
              ))}
            </Box>
          </Fade>
        </Box>
    


      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          href={card.link}
          sx={{
            backgroundColor: '#fff',
            color: card.color,
            textTransform: 'none',
            fontWeight: 'bold',
            borderRadius: '20px',
            px: 2,
            py: 0.5,
            fontSize: '12px',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          {card.title === 'Want to See More?' ? 'Learn More' : 'Learn More'}
        </Button>

        {/* Icon image beside the button */}
        <Box
          component="img"
          src={card.iconSrc}
          alt={`${card.title} icon`}
          sx={{
            width: 80,
            height: 80,

          }}
        />
      </Box>


    </Paper>
  );
}